'use client'

import ScrollLoad from '@/components/layout/scrollLoad'
import { Article } from '@/entities/article'
import { insightsListAction } from '@/lib/actions/insights'
import { insightsPageSize } from '@/lib/config'
import { createContext, useContext } from 'react'
import { useAsyncFn, useList } from 'react-use'

const DataViewContext = createContext<{ data: Article[] }>({ data: [] })

export function DataViewContextProvider({
  data,
  total,
  query,
  index,
  children,
}: {
  data: Article[]
  total: number
  query?: string
  index: number
  children: React.ReactNode
}) {
  const [viewData, { push: pushData }] = useList(data)
  const [loadState, handleLoad] = useAsyncFn(async (pageIndex: number) => {
    const res = await insightsListAction(query, pageIndex)
    pushData(...(res?.data || []))
  })

  return (
    <DataViewContext.Provider value={{ data: viewData }}>
      {children}
      <ScrollLoad
        initIndex={index}
        loading={loadState.loading}
        total={total}
        size={insightsPageSize}
        onLoad={handleLoad}
        className='py-4'
      />
    </DataViewContext.Provider>
  )
}

export function useDataViewContext() {
  return useContext(DataViewContext)
}
